<template>
  <div class="os-icon">
    <div class="os-element">
      <span class="os-system">win</span>
      <span class="os-version">
        {{ version() }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "OsElement",
  props: ["os"],
  methods: {
    version() {
      let os = this.os.replace("X", "x");
      let temp = os.split("x");
      let version = temp[0].replace("win", "").toLocaleUpperCase();
      return version;
    },
  },
};
</script>

<style scoped lang="scss">
.os-icon {
  // margin-top: 20px;
  /*margin-bottom: 10px;*/
  width: 60px;
  height: 60px;
  display: inline-block;
  background: #e2fef0;
  border-radius: 100%;
  color: #1cd26b;

  position: relative;

  .os-element {
    position: absolute;
    top: 12px;
    width: 100%;
    text-align: center;
    line-height: 1.2;
  }

  .os-system {
    display: block;
    font-size: 13px;
  }

  .os-version {
    display: block;
    font-weight: bold;
    font-size: 18px;
  }
}
</style>